// Darkens a hex color by `amount` percentage points of lightness, matching
// tinycolor2's `.darken(amount).toRgbString()` (HSL model, lightness clamped).
export const darkenHex = (hex: string, amount: number): string => {
	const h = hex.replace("#", "");
	const r = parseInt(h.slice(0, 2), 16) / 255;
	const g = parseInt(h.slice(2, 4), 16) / 255;
	const b = parseInt(h.slice(4, 6), 16) / 255;

	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	let hue = 0;
	let sat = 0;
	let light = (max + min) / 2;

	if (max !== min) {
		const d = max - min;
		sat = light > 0.5 ? d / (2 - max - min) : d / (max + min);
		switch (max) {
			case r:
				hue = (g - b) / d + (g < b ? 6 : 0);
				break;
			case g:
				hue = (b - r) / d + 2;
				break;
			default:
				hue = (r - g) / d + 4;
		}
		hue /= 6;
	}

	light = Math.min(1, Math.max(0, light - amount / 100));

	let R: number;
	let G: number;
	let B: number;
	if (sat === 0) {
		R = G = B = light;
	} else {
		const hue2rgb = (p: number, q: number, t: number) => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};
		const q = light < 0.5 ? light * (1 + sat) : light + sat - light * sat;
		const p = 2 * light - q;
		R = hue2rgb(p, q, hue + 1 / 3);
		G = hue2rgb(p, q, hue);
		B = hue2rgb(p, q, hue - 1 / 3);
	}

	return `rgb(${Math.round(R * 255)}, ${Math.round(G * 255)}, ${Math.round(B * 255)})`;
};
